import { render, staticRenderFns } from "./carnival.vue?vue&type=template&id=51d2bc8e&"
import script from "./carnival.vue?vue&type=script&lang=js&"
export * from "./carnival.vue?vue&type=script&lang=js&"
import style0 from "./carnival.vue?vue&type=style&index=0&id=51d2bc8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports